import { 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  TablePagination,
} from '@mui/material';
import { Notice } from '../type';
import { useState } from 'react';
import { formatDate } from '../utils/dateUtils';

interface NoticeTableProps {
  data: Notice[];
  onNoticeSelect: (notice: Notice) => void;
}

export const NoticeTable = ({
  data,
  onNoticeSelect,
}: NoticeTableProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ width: '100%' }}>
      <TableContainer>
        <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>공지사항 ID</TableCell>
                <TableCell>제목</TableCell>
                <TableCell>배너</TableCell>
                <TableCell>작성일</TableCell>
                <TableCell>공개</TableCell>
                <TableCell>공개위치</TableCell>
                <TableCell>공개순서</TableCell>
                <TableCell>팝업표시</TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
            {pagedData.map((row, index) => (
              <TableRow key={row.noticeId || `notice-${index}`} hover style={{ cursor: 'pointer' }} onClick={() => onNoticeSelect(row)}>
                <TableCell>{row.noticeId}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>
                  {row.bannerImageUrl ? 'O' : 'X'}
                </TableCell>
                <TableCell>{formatDate(row.createdAt)}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      display: 'inline-block',
                      px: 1,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: '0.75rem',
                      fontWeight: 'bold',
                      backgroundColor: row.isPublic ? '#e8f5e8' : '#ffebee',
                      color: row.isPublic ? '#2e7d32' : '#c62828',
                    }}
                  >
                    {row.isPublic ? '전체공개' : ((row.allowedEnterprises?.length ?? 0) > 0 || (row.allowedUsers?.length ?? 0) > 0) ? '공개' : '비공개'}
                  </Box>
                </TableCell>
                <TableCell>{row.placement}</TableCell>
                <TableCell>{row.order ? row.order : 0}</TableCell>
                <TableCell>{row.isPopup ? 'O' : 'X'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={data.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
    </Box>
  );
}; 